import { apiErrorCode, type ChronumLoad } from '@shared/api';

/** 409 `stale_version`: сопоставление изменил кто-то другой, пока его правили. */
export function isStaleError(err: unknown): boolean {
  return apiErrorCode(err) === 'stale_version';
}

function isLoad(v: unknown): v is ChronumLoad {
  return (
    typeof v === 'object' &&
    v !== null &&
    'id' in v &&
    typeof v.id === 'string' &&
    'status' in v &&
    typeof v.status === 'string' &&
    'period' in v &&
    typeof v.period === 'string'
  );
}

/** 409 `load_running`: за месяц уже идёт загрузка — она в теле ответа. */
export function runningLoadOf(err: unknown): ChronumLoad | null {
  if (apiErrorCode(err) !== 'load_running') return null;
  if (typeof err !== 'object' || err === null || !('data' in err)) return null;
  const data = err.data;
  if (typeof data !== 'object' || data === null || !('load' in data)) return null;
  return isLoad(data.load) ? data.load : null;
}
